import RiInformationLine from '@ben/icons/information-line';
import { Accordion } from '@ben/orion/accordion';
import EmptyState from '@ben/orion/empty-state';
import { isEmpty } from 'lodash';
import { useTranslation } from 'react-i18next';
import type { Feature } from './item';
import FeatureItem from './item';

interface ManageBenefitFeaturesListProps {
  features: Feature[];
  onChangeFeature: (index: number, feature: Feature) => void;
  onRemoveFeature: (index: number) => void;
  showRankField?: boolean;
}

const ManageBenefitFeaturesList = ({
  features,
  onChangeFeature,
  onRemoveFeature,
  showRankField,
}: ManageBenefitFeaturesListProps) => {
  const { t } = useTranslation();
  if (isEmpty(features)) {
    return (
      <EmptyState
        title={t('manageBenefitFeatures.emptyState.title', {
          defaultValue: 'No features added',
        })}
        info={t('manageBenefitFeatures.emptyState.info', {
          defaultValue:
            'Add features to help employees better understand the benefit.',
        })}
        icon={RiInformationLine}
      />
    );
  }
  return (
    <Accordion chevronPosition="left">
      {features.map((feature, index) => (
        <FeatureItem
          key={index}
          feature={feature}
          index={index}
          onChangeFeature={(feature) => onChangeFeature(index, feature)}
          onRemoveFeature={() => onRemoveFeature(index)}
          showRankField={showRankField}
        />
      ))}
    </Accordion>
  );
};

export default ManageBenefitFeaturesList;
